// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomInput_wrapper__bXYbv","label":"CustomInput_label__i-YLv","errorMessage":"CustomInput_errorMessage__dM-M6"};